import { nanoid } from 'nanoid';
import * as React from 'react';
import styled from 'styled-components';

import { RequiredAuthFake } from '../../../Auth/RequiredAuthFake';
import { Button } from '../../../ButtonV2/ButtonV2';
import { colorsV2 } from '../../../colors-v2';
import { Typography } from '../../../DesignSystemV2/Typography';

/* eslint-disable no-nested-ternary */
/* stylelint-disable */
const Main = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  font-family: Inter, sans-serif;

  .btn-check-wrapper {
    width: 100%;
    display: grid;
    justify-content: flex-end;
    text-align: right;
  }
`;

interface ExerciseDoTestActionsProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'id'> {
  check: () => void;
  retry: () => void;
  isViewResult: boolean;
  lastResult: {
    correct: number;
    total: number;
  };
  retryCount: number;
  isLoginRequired?: boolean;
}

export const ExerciseDoTestActions = (props: ExerciseDoTestActionsProps) => {
  const {
    check,
    retry,
    isViewResult,
    lastResult,
    retryCount,
    isLoginRequired = true,
    ...rest
  } = props;
  const [id] = React.useState(nanoid());

  const onRetry = () => {
    retry();
  };

  return (
    <Main className="exercise-do-test-actions" key={id} id={id} contentEditable={false} {...rest}>
      {!isViewResult && (
        <>
          {retryCount > 0 && (
            <>
              <Typography.Text variant="semi-bold/16" color="blue100">
                {`Your last result is ${lastResult?.correct || 0}/${lastResult?.total || 0}`}
              </Typography.Text>
              <Button.Primary onClick={() => check()}>
                <Typography.Text variant="semi-bold/16">Check answer</Typography.Text>
              </Button.Primary>
            </>
          )}
          {retryCount === 0 ? (
            <>
              <div />
              {isLoginRequired ? (
                <RequiredAuthFake
                  title="Chức năng này chỉ dành riêng cho thành viên của dolacademy.vn"
                  onLoginSuccess={check}
                >
                  {({ forceLoginToProceedAction }) => (
                    <Button.Primary onClick={() => forceLoginToProceedAction(check)}>
                      <Typography.Text variant="semi-bold/16">Check answer</Typography.Text>
                    </Button.Primary>
                  )}
                </RequiredAuthFake>
              ) : (
                <Button.Primary onClick={() => check()}>
                  <Typography.Text variant="semi-bold/16">Check answer</Typography.Text>
                </Button.Primary>
              )}
            </>
          ) : null}
        </>
      )}
      {isViewResult && (
        <>
          <Typography.Text variant="semi-bold/16" color="blue100">
            {retryCount === 0
              ? `You got ${lastResult?.correct || 0}/${lastResult?.total || 0} correct"`
              : `Your last result is ${lastResult?.correct || 0}/${lastResult?.total || 0}`}
          </Typography.Text>
          <Button.Primary style={{ backgroundColor: colorsV2.blue100 }} onClick={() => onRetry()}>
            <Typography.Text variant="semi-bold/16">Do it again</Typography.Text>
          </Button.Primary>
        </>
      )}
    </Main>
  );
};
